import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import Shell from "../components/Shell.jsx";
import SnapReceiptButton from "../components/ReceiptCapture.jsx";
import { api } from "../lib/api.js";
import { centsToDisplay } from "../lib/money.js";

const STATUS_CHIP = {
  pending: ["Needs review", "bg-amber-100 text-amber-800"],
  failed: ["Couldn't read", "bg-red-100 text-red-700"],
  confirmed: ["Filed", "bg-emerald-100 text-emerald-700"],
};

export default function Receipts() {
  const navigate = useNavigate();
  const [receipts, setReceipts] = useState(null);

  useEffect(() => {
    api("/api/receipts").then((d) => setReceipts(d.receipts)).catch(() => setReceipts([]));
  }, []);

  return (
    <Shell title="Receipts">
      <SnapReceiptButton
        label="📷 Snap a receipt"
        className="w-full rounded-2xl bg-navy-700 py-4 text-center text-base font-semibold text-white shadow-sm disabled:opacity-60"
        onCaptured={({ id }) => navigate(`/receipts/${id}/review`)}
      />

      {receipts === null && <p className="text-center text-sm text-slate-400">Loading…</p>}
      {receipts?.length === 0 && (
        <div className="rounded-2xl border border-dashed border-slate-300 bg-white p-8 text-center">
          <p className="text-4xl">🧾</p>
          <p className="mt-3 font-medium text-slate-700">No receipts yet</p>
          <p className="mt-1 text-sm text-slate-500">Snap one and the AI files it for you.</p>
        </div>
      )}

      <div className="grid grid-cols-3 gap-3">
        {(receipts || []).map((r) => {
          const [label, cls] = STATUS_CHIP[r.status] || STATUS_CHIP.pending;
          const target = r.linked_transaction_id ? `/edit/${r.linked_transaction_id}` : `/receipts/${r.id}/review`;
          return (
            <Link key={r.id} to={target} className="overflow-hidden rounded-xl bg-white shadow-sm">
              <div className="relative flex aspect-[3/4] w-full items-center justify-center bg-slate-100">
                <span className="text-3xl">{r.source === "email" ? "📧" : "🧾"}</span>
                <img
                  src={`/api/receipts/${r.id}/image?size=thumb`}
                  alt=""
                  loading="lazy"
                  className="absolute inset-0 h-full w-full object-cover"
                  onError={(e) => e.currentTarget.remove()}
                />
              </div>
              <div className="space-y-0.5 p-1.5">
                <span className={`inline-block rounded px-1.5 py-0.5 text-[10px] font-semibold ${cls}`}>{label}</span>
                {r.ocr?.total_cents ? (
                  <p className="truncate text-xs font-medium text-slate-700">
                    {centsToDisplay(r.ocr.total_cents)} {r.ocr.merchant ? `· ${r.ocr.merchant}` : ""}
                  </p>
                ) : null}
              </div>
            </Link>
          );
        })}
      </div>
    </Shell>
  );
}
